import { useFormatNumber } from '../../../../../core/hooks/useFormatNumber'
import { useFormatAmount } from '../../../../../core/hooks/useFormatAmount'

interface GoalStatusLabelProps {
  directorGmv?: number
  teamsGmv?: number
  currency: string
}

const GmvForecastGapSummary = ({ directorGmv, teamsGmv, currency }: GoalStatusLabelProps) => {
  const formatNumber = useFormatNumber()
  const formatAmount = useFormatAmount()

  const isError = directorGmv == null || teamsGmv == null || teamsGmv === 0

  const gapPercentage = Math.abs(100 - (directorGmv * 100) / teamsGmv)

  const gapPercentageStatus = gapPercentage > 10 ? 'bad' : gapPercentage > 5 ? 'medium' : 'good'
  const formattedGapPercentage = formatNumber(gapPercentage / 100, '', { style: 'percent', maximumFractionDigits: 2 })

  const gapAmount = directorGmv - teamsGmv
  const formattedAmount = formatAmount(gapAmount ?? 0, currency)

  return (
    <>
      {isError && (
        <div
          className="mg-weekly-gmv-gap-percentage-and-value mg-weekly-gmv-gap-percentage-and-value-error"
          data-testid="error"
        >
          <div className="vp-body-l" data-testid="gap-percentage">
            --
          </div>
          <div className="vp-caption mg-weekly-gmv-gap-value" data-testid="gap-value">
            --
          </div>
        </div>
      )}

      {!isError && (
        <div className="mg-weekly-gmv-gap-percentage-and-value">
          <div
            className={`vp-body-l mg-weekly-gmv-gap-percentage mg-weekly-gmv-gap-percentage__${gapPercentageStatus}`}
            data-testid="gap-percentage"
          >
            {formattedGapPercentage}
          </div>

          <div className="vp-caption mg-weekly-gmv-gap-value" data-testid="gap-value">
            ({formattedAmount})
          </div>
        </div>
      )}
    </>
  )
}

export default GmvForecastGapSummary
